import { Component, OnInit } from "@angular/core";
import { Classificacao } from "src/app/models/registro-produto";
import { HabilTrackerService } from "../service/tracker.service";
import { MenuItem, MessageService, SelectItem } from "primeng/api";
import {
  ClassificacaoDTO,
  FiltrosDetalhesDTO,
  FiltrosRegistroDTO,
  RegistroDTO,
  RegistrosPorClassificacaoDTO,
} from "../dto/ConsultaRegistroDTO";
import { clone } from "src/app/utilities/util/clone-utils";
import { DialogService } from "primeng/dynamicdialog";
import { DashboardDetalhesComponent } from "./dashboard-detalhes/dashboard-detalhes.component";

@Component({
  selector: "habil-dashboard-public",
  templateUrl: "./dashboard-public.component.html",
  styleUrls: ["./dashboard-public.component.scss"],
})
export class DashboardPublicComponent implements OnInit {
  loading: boolean = false;
  classificacoes: ClassificacaoDTO[];
  filtro: FiltrosRegistroDTO = new FiltrosRegistroDTO();

  classificacoesDropdown: SelectItem[] = [];

  registros: RegistrosPorClassificacaoDTO[] = [];
  filtroResult: FiltrosRegistroDTO;

  constructor(
    public tracker: HabilTrackerService,
    public message: MessageService,
    public dialog: DialogService
  ) {}

  async ngOnInit() {
    await this.carregaInfos();
  }

  async carregaInfos() {
    this.classificacoes = await this.tracker.getClassificacoes();
    if (this.classificacoes?.length) {
      this.classificacoesDropdown = this.classificacoes.map((c) => ({
        label: c.descricao,
        value: c,
      }));

      this.filtro.classificacoes = this.classificacoesDropdown
        .filter((c) => [5, 11, 19].includes(c.value.id))
        .map((r) => r.value);
      this.buscarDadosRegistros();
    }
  }

  buscarDadosRegistros() {
    if (!this.filtro?.classificacoes?.length && !this.filtro?.search) {
      return this.message.add({
        severity: "info",
        summary: "Aviso",
        detail: "Escolha um parâmetro para busca!",
      });
    }
    this.loading = true;
    this.tracker
      .getDadosRegistros(this.filtro)
      .then((value) => {
        if (value?.registros?.length) {
          this.filtroResult = clone(this.filtro);
          this.registros = value.registros;
          this.message.add({
            severity: "success",
            summary: "Sucesso",
            detail: "Busca realizada com sucesso!",
          });
        } else {
          this.message.add({
            severity: "info",
            summary: "Aviso",
            detail: "Nenhum registro encontrado!",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.message.add({
          severity: "error",
          summary: "Erro",
          detail: "Ocorreu um erro durante a busca.",
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  getMediaPersonalizada(registro: RegistrosPorClassificacaoDTO) {
    const diffMs =
      this.filtroResult.dataFinal.getTime() -
      this.filtroResult.dataInicial.getTime();
    const totalDias = Math.floor(diffMs / (1000 * 60 * 60 * 24)) + 1;
    return this.formatValue(
      registro.personalizado.length / (totalDias || 1) || 0
    );
  }

  getTotalDia() {
    return this.registros.reduce((acc, r) => acc + (r?.dia?.length || 0), 0);
  }

  getTotalMes() {
    return this.registros.reduce((acc, r) => acc + (r?.mes?.length || 0), 0);
  }

  getTotalAno() {
    return this.registros.reduce((acc, r) => acc + (r?.ano?.length || 0), 0);
  }

  getTotalPersonalizado() {
    return this.registros.reduce(
      (acc, r) => acc + (r?.personalizado?.length || 0),
      0
    );
  }

  formatValue(value: number) {
    return Number(value).toFixed(2);
  }

  abrirDetalhes(
    data: RegistrosPorClassificacaoDTO,
    tipo: "DIA" | "MES" | "ANO" | "PERSONALIZADO"
  ) {
    let registros: RegistroDTO[];
    let label: string;
    switch (tipo) {
      case "DIA":
        registros = data.dia;
        label = "Dia";
        break;
      case "MES":
        registros = data.mes;
        label = "Mês";
        break;
      case "ANO":
        registros = data.ano;
        label = "Ano";
        break;
      case "PERSONALIZADO":
        registros = data.personalizado;
        label = "Personalizado";
        break;
    }
    const filtro: FiltrosDetalhesDTO = {
      tipo: tipo,
      registros: registros,
      dataInicial: this.filtroResult.dataInicial,
      dataFinal: this.filtroResult.dataFinal,
    };

    this.dialog.open(DashboardDetalhesComponent, {
      header: `${data.classificacao.descricao} - ${label}`,
      data: {
        classificacao: data.classificacao,
        dto: filtro,
      },
    });
  }
}
